export const heroImg = require('../assets/images/fodc/Rectangle.png')
export const Benefits1 = require('../assets/images/fodc/benefits1 icon.svg')
export const Benefits2 = require('../assets/images/fodc/befefits2 icon.svg')
export const Benefits3 = require('../assets/images/fodc/benefits3 icon.svg')
export const Benefits4 = require('../assets/images/fodc/benefits4 icon.svg')
export const RightArrow = require('../assets/images/fodc/guidance_up-arrow.svg')